import React from "react";
import "../css/WaitingRoom.css";

const WaitingRoom = () => {
  return (
    <div className="waiting-room">
      <h2>⏳ Waiting for a teacher to assist you...</h2>
      <p>In the meantime, you may continue chatting with AskTeach AI.</p>
    </div>
  );
};

export default WaitingRoom;
